<template>
  <div class="logout__container">
    <div class="mds-layout-grid">
      <div class="mds-layout-grid__row">
        <div class="mds-layout-grid__col mds-layout-grid__col--squeeze-3">
          <mds-loader />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AuthMixin from '@/mixins/AuthMixin';

export default {
  name: 'logout',
  mixins: [AuthMixin],
  data() {
    return {
      uimLoginUrl: `${process.env.VUE_APP_UIM_URL}${process.env.VUE_APP_UIM_LOGIN_ENDPOINT}?`
        + `source=${process.env.VUE_APP_UIM_SOURCE}&`
        + `targetUrl=${process.env.VUE_APP_UIM_TARGET_URL}`,
    };
  },
  computed: {
    uimLogoutUrl() {
      return `${process.env.VUE_APP_UIM_URL}${process.env.VUE_APP_UIM_LOGOUT_ENDPOINT}?`
        + `returnTo=${encodeURIComponent(this.uimLoginUrl)}&`
        + `clientId=${process.env.VUE_APP_UIM_CLIENT_ID}`;
    },
  },
  async created() {
    await this.cleanAuthTokenIdAndStoreAndThenExit();
    this.logout();
  },
  methods: {
    logout() {
      window.location.href = this.uimLogoutUrl;
    },
  },
};
</script>
<style lang="scss" scoped>
.logout {
  &__container {
    padding-top: $mds-space-inset-4-x;
    width: 100%;
  }
}
</style>
